<template>
  <div id="app" class="app-wrapper">
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'App',
  created() {
    this.submitDevice();
    this.userDevice === 'm' && this.deviceIsMobile();
  },
  computed: {
    ...mapGetters(['userDevice', 'IOSDeviceVersion']),
  },
  methods: {
    ...mapActions(['submitDevice', 'submitIOSVersion', 'submitIPhone']),
    deviceIsMobile () {
      this.submitIOSVersion();
      this.IOSDeviceVersion === 13 && this.setIOSWrapperCSSForOverflow();
      this.submitIPhone();
    },
    setIOSWrapperCSSForOverflow () {
      const bodySelector = document.querySelector('body');
      const htmlSelector = document.querySelector('html');

      bodySelector.style.overflow = 'visible';
      bodySelector.style.position = 'static';
      htmlSelector.style.overflow = 'auto';
    }
  },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');

html, body {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  padding: 0;
  margin: 0;
  background-color: #faf9f8;
}

.app-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  overflow: auto;
  background-color: black;
}
</style>
